export const pleOptions = {
	series: [
		{
			name: '1',
			data: [44, 55, 41, 67, 22, 43, 14, 105, 221, 17, 2, 83],
		},
	],
	chart: {
		type: 'bar',
		height: 350,
		stacked: true,
		toolbar: {
			show: false,
		},
		zoom: {
			enabled: true,
		},
	},
	noData: {
		text: 'Sem Dados',
		align: 'center',
		verticalAlign: 'middle',
		offsetX: 0,
		offsetY: 0,
		style: {
			color: undefined,
			fontSize: '14px',
			fontFamily: undefined,
		},
	},
	responsive: [
		{
			breakpoint: 480,
			options: {
				legend: {
					position: 'bottom',
					offsetX: -10,
					offsetY: 0,
				},
				yaxis: {
					show: false,
				},
			},
		},
	],
	plotOptions: {
		bar: {
			horizontal: false,
			borderRadius: 6,
			borderRadiusApplication: 'end',
			borderRadiusWhenStacked: 'last',
			dataLabels: {
				total: {
					enabled: false,
				},
			},
		},
	},
	dataLabels: {
		enabled: false,
	},
	colors: ['#4D82E9'],
	xaxis: {
		type: 'text',
		//   categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro',
		// 				'Outubro', 'Novembro', 'Dezembro'
		// 			],
	},
	yaxis: {
		show: true,
		floating: false,
		labels: {
			formatter: function (val, index) {
				let value = GLOBAL.FormatREALVirgula(String(val))

				return `R$ ${value.split(',')[0]}`
			},
		},
	},
	subtitle: {
		text: 'PLE',
		offsetY: 5,
		style: {
			fontSize: '12px',
			fontWeight: '600',
			fontFamily: undefined,
			color: '#949799',
		},
	},
	legend: {
		position: 'bottom',
		horizontalAlign: 'center',
		offsetY: 7,
	},
	fill: {
		opacity: 1,
	},
	grid: {
		show: true,
		xaxis: {
			lines: {
				show: true,
			},
		},
		yaxis: {
			lines: {
				show: true,
			},
		},
	},
}
